module.exports = __webpack_public_path__ + "static/media/portfolio-details-2.1ff8dc61.jpg";